import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=5109a6b8"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=5109a6b8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5109a6b8')) {
      api.createRecord('5109a6b8', component.options)
    } else {
      api.reload('5109a6b8', component.options)
    }
    module.hot.accept("./forgotPassword.vue?vue&type=template&id=5109a6b8", function () {
      api.rerender('5109a6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/setup/components/forgotPassword/forgotPassword.vue"
export default component.exports